import React, {Component} from 'react';
import {DEVICE_DESKTOP, DEVICE_MOBILE} from 'config';
import {DesktopLineupsListComponent} from './desktop-lineups-list';
import {MobileLineupsListComponent} from './mobile-lineups-list';

class LineupsList extends Component {
    render() {
        const {deviceType = DEVICE_DESKTOP} = this.props;

        return deviceType === DEVICE_MOBILE ? <MobileLineupsListComponent /> : <DesktopLineupsListComponent />;
    }
}

export {LineupsList};
